import React from 'react';
export function TermsContent() {
  return <>
      <p className="text-sm uppercase tracking-widest text-gold-400" data-id="element-39">
        Última actualización: Mayo 2026
      </p>

      <p data-id="element-40">
        Bienvenido al{' '}
        <strong className="text-white font-medium" data-id="element-41">
          Protocolo de Sueño Profundo 50+
        </strong>
        . Al adquirir y utilizar esta guía digital, aceptas los siguientes
        términos y condiciones. Te pedimos leerlos con atención.
      </p>

      <Section title="1. Naturaleza del producto" data-id="element-42">
        El Protocolo de Sueño Profundo 50+ es una guía digital educativa que
        incluye material en formato PDF y audio. No es un dispositivo médico, no
        diagnostica, trata o cura ninguna enfermedad, y no sustituye la consulta
        con un profesional de la salud.
      </Section>

      <Section title="2. Uso personal" data-id="element-43">
        Tu compra te otorga una licencia personal, no transferible y no
        exclusiva para acceder al contenido. Está prohibida la reventa,
        redistribución, copia o reproducción total o parcial del material sin
        autorización por escrito.
      </Section>

      <Section title="3. Resultados" data-id="element-44">
        Los resultados pueden variar de persona a persona. Aunque muchos
        usuarios reportan mejoras notables en pocos días, no garantizamos
        resultados específicos. La constancia en la aplicación del protocolo es
        fundamental.
      </Section>

      <Section title="4. Recomendación médica" data-id="element-45">
        Si padeces alguna condición de salud, tomas medicamentos o tienes dudas
        sobre tu sueño, te recomendamos consultar a tu médico antes de aplicar
        cualquiera de las técnicas descritas.
      </Section>

      <Section title="5. Garantía de satisfacción" data-id="element-46">
        Ofrecemos una garantía de 30 días desde la fecha de compra. Si no estás
        satisfecho con el producto, puedes solicitar el reembolso completo
        escribiéndonos. Sin preguntas, sin complicaciones.
      </Section>

      <Section title="6. Pago y acceso" data-id="element-47">
        El pago es único y se procesa a través de plataformas seguras. El acceso
        al material es inmediato una vez confirmado el pago, mediante enlace de
        descarga.
      </Section>

      <Section title="7. Modificaciones" data-id="element-48">
        Nos reservamos el derecho de actualizar estos términos en cualquier
        momento. Los cambios serán comunicados en esta misma página.
      </Section>

      <Section title="8. Contacto" data-id="element-49">
        Para cualquier consulta sobre estos términos, escríbenos a
        soporte@suenoprofundo50.com. Respondemos en menos de 48 horas hábiles.
      </Section>
    </>;
}
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div data-id="element-50">
      <h3 className="text-lg font-serif text-white mb-2" data-id="element-51">{title}</h3>
      <p data-id="element-52">{children}</p>
    </div>;
}